// --------------------------------------------------------------------------
// Bird selector that uses the new autocomplete module.
// This module uses a copy of bird-select.js module's function 'clone-bird'.
// --------------------------------------------------------------------------
// Author:      RSPB

'use strict';

var $ = require('jquery');
var events = require('common-js-pub-sub')();

module.exports = function (options) {
    var ref = { $root: options.context, $document: $(document) };
    var state = {
        birdId: '',
        birdName: '',
        birdResourceKey: '',
        selectIndex: -1
    };

    function init() {
        var addButton = ref.$root.find('[data-binding="bird-select-autocomplete-add-button"]');
        var birdSelect = ref.$root.find('[name="bird-select-autocomplete"]');

        birdSelect.on('select.editable-select', function (e, li) {
            if (typeof li !== 'undefined') {
                var values = li.attr('value').split('|');
                state.selectIndex = li.index(); // used for removing option from the drop-down
                state.birdId = values[0]; // bird-7ef3dd-a742-4c... (GUID)
                state.birdResourceKey = values[1]; // Feral_pigeon
                state.birdName = li.text(); // Feral pigeon (no underscore)
            }
        });

        addButton.on('click', function (e) {
            e.preventDefault();

            var birdList = ref.$document.find('[data-binding="bird-list"]');

            if (state.birdId.length > 0 && state.birdName.length > 0 && state.birdResourceKey.length > 0) {
                events.publish('clone-bird', {
                    toClone: birdList.find('[data-binding="bird-item"]').parent().last(),
                    name: state.birdName,
                    id: state.birdId,
                    resourceKey: state.birdResourceKey
                });

                // remove the added item from the select's list
                birdSelect.editableSelect('remove', state.selectIndex);

                // reset state values after the option has been removed
                state.selectIndex = -1;
                state.birdName = '';
                state.birdId = '';
                state.birdResourceKey = '';

                // reset the input field and focus so that user can enter another species
                birdSelect.val('').focus();
            }
        });
    }

    // This is a copy from bird-select.js module, it has to diverge as data-behavior="bird-select"
    // is also used on the "telluswhatyousaw" page when Model.GardenCreatures is not empty and that
    // part wasn't updated with the new autocomplete drop-down
    events.subscribe('clone-bird', function (options) {
        var elementToBeCloned = options.toClone;
        var clone = elementToBeCloned.clone();
        var cloneName = options.name;
        var cloneId = options.id;
        var cloneResourceKey = options.resourceKey;

        clone = clone[0].outerHTML;

        clone = $(clone);

        var clonedIndex = parseInt(clone.attr('data-index'));
        var newIndex = clonedIndex + 1;
        var nameAttrPrefix = 'Birds[' + newIndex + '].';

        /// Update DOM
        clone.attr('data-index', newIndex);

        clone.find('[data-binding="bird-name"]').text(cloneName);
        clone.find('[data-binding="bird-image"]')[0].src = '/Static/images/bgbw/birds/' + cloneId + '.jpg';

        clone.find('[data-binding="bird-name"]').attr('for', cloneId);

        clone.find('input[data-binding="input-id"]').attr('id', 'Birds_' + newIndex + '__Id').attr('name', nameAttrPrefix + 'Id').val(cloneId);

        clone.find('input[data-binding="input-name"]').attr('id', 'Birds_' + newIndex + '__Name').attr('name', nameAttrPrefix + 'Name').val(cloneResourceKey);

        clone.find('input[data-binding="input-number"]').attr('id', cloneId).attr('name', nameAttrPrefix + 'Count').val('0').hide();

        clone.find('[data-binding="decrease-number"]').hide();

        /// Bind a new click element (see input-number.js)
        clone.one('click', function (e) {
            e.stopPropagation();
            clone.find('[data-binding="increase-number"]').trigger('click');
        });

        /// Insert the clone
        elementToBeCloned.after(clone);
    });

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/bgbw/bird-select-autocomplete.js
// module id = 510
// module chunks = 0